import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a34cfec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_quick_settlement",
  ref: "addQuickSettlementModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_quick_settlement_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_quick_settlement_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_quick_settlement_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_quick_settlement_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-7" }
const _hoisted_13 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-7" }
const _hoisted_16 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-7" }
const _hoisted_19 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_20 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_21 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mb-7" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_25 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_26 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group mb-7" }
const _hoisted_29 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "form-group mb-7" }
const _hoisted_32 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = { class: "form-group mb-7" }
const _hoisted_35 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "form-group mb-7" }
const _hoisted_38 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "el-upload__tip" }
const _hoisted_41 = { class: "modal-footer flex-center" }
const _hoisted_42 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "indicator-label" }
const _hoisted_45 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_46 = { class: "indicator-progress" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.add")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("quickSettlement.type")), 1),
                      _createVNode(_component_el_form_item, { prop: "order_type" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.order_type,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.order_type) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.type, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("quickSettlement.customer")), 1),
                      _createVNode(_component_el_form_item, { prop: "customer_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            ref: "selectCustomer",
                            onVisibleChange: _ctx.cancelReadonly,
                            modelValue: _ctx.formData.customer,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.customer) = $event)),
                            filterable: "",
                            clearable: "",
                            remote: "",
                            placeholder: _ctx.t('common.plsEnter'),
                            "remote-method": _ctx.searchCustomerItems,
                            loading: _ctx.options.customerLoading,
                            style: {"width":"100%"},
                            onChange: _ctx.customerChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.customer, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onVisibleChange", "modelValue", "placeholder", "remote-method", "loading", "onChange"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("quickSettlement.orderAmount")), 1),
                      _createVNode(_component_el_form_item, { prop: "order_amount" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_el_input_number, {
                              class: "text-start w-100",
                              modelValue: _ctx.formData.order_amount,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.order_amount) = $event)),
                              precision: 2,
                              step: 0.01,
                              min: 0,
                              controls: false
                            }, null, 8, ["modelValue", "step"]),
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.formData.order_currency,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.order_currency) = $event)),
                                placeholder: _ctx.t('common.plsSelect'),
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.currency, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("quickSettlement.paidAmount")), 1),
                      _createVNode(_component_el_form_item, { prop: "pay_amount" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_el_input_number, {
                              class: "text-start w-100",
                              modelValue: _ctx.formData.pay_amount,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.pay_amount) = $event)),
                              precision: 2,
                              step: 0.01,
                              min: 0,
                              controls: false
                            }, null, 8, ["modelValue", "step"]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.formData.pay_currency,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.pay_currency) = $event)),
                                placeholder: _ctx.t('common.plsSelect'),
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.currency, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t("quickSettlement.distributionModel")), 1),
                      _createVNode(_component_el_form_item, { prop: "distribution_model" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.distribution_model,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.distribution_model) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.distribution_model, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t("quickSettlement.dueDate")), 1),
                      _createVNode(_component_el_form_item, { prop: "due_date" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.due_date,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.due_date) = $event)),
                            type: "date",
                            clearable: "",
                            placeholder: _ctx.t('common.pickDate'),
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (
                          _ctx.commonChangeDefaultDate($event, _ctx.formData, 'due_date')
                        )),
                            format: "DD.MM.YYYY"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.t("quickSettlement.remark")), 1),
                      _createVNode(_component_el_form_item, { prop: "comment" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.comment,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.comment) = $event)),
                            type: "textarea",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("quickSettlement.selectFile")), 1),
                      _createVNode(_component_el_form_item, { prop: "file_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_upload, {
                            ref: "uploadRefs.file_id",
                            accept: ".xls,.xlsx",
                            "file-list": _ctx.uploadData.file_id,
                            action: _ctx.uploadUrl,
                            headers: _ctx.uploadHeaders,
                            disabled: _ctx.uploadDisabled.file_id,
                            limit: 1,
                            "auto-upload": true,
                            "on-progress": 
                          function (e, file, fileList) {
                            return _ctx.handleProgress(e, file, fileList, 'file_id');
                          }
                        ,
                            "on-success": 
                          function (response, file, fileList) {
                            return _ctx.handleSuccess(
                              response,
                              file,
                              fileList,
                              'file_id',
                              _ctx.formData
                            );
                          }
                        ,
                            "on-error": 
                          function (err, file, fileList) {
                            return _ctx.handleError(err, file, fileList, 'file_id');
                          }
                        ,
                            "on-remove": 
                          function (file, fileList) {
                            return _ctx.handleRemove(
                              file,
                              fileList,
                              'file_id',
                              _ctx.formData,
                              _ctx.uploadData,
                              _ctx.removeFlag
                            );
                          }
                        ,
                            "on-exceed": 
                          function (files, fileList) {
                            return _ctx.handleExceed(files, fileList, 'file_id');
                          }
                        ,
                            "before-upload": _ctx.handleBeforeUpload
                          }, {
                            tip: _withCtx(() => [
                              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.t("quickSettlement.uploadTip")), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary btn-sm me-2",
                                disabled: _ctx.uploadDisabled.file_id
                              }, _toDisplayString(_ctx.$t("common.fileUpload")), 9, _hoisted_39)
                            ]),
                            _: 1
                          }, 8, ["file-list", "action", "headers", "disabled", "on-progress", "on-success", "on-error", "on-remove", "on-exceed", "before-upload"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_42, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
              ]),
              _createElementVNode("button", {
                ref: "submitButton",
                type: "submit",
                class: "btn btn-lg btn-primary",
                disabled: _ctx.loading || _ctx.uploadDisabled.file_id
              }, [
                _createElementVNode("span", _hoisted_44, [
                  _createElementVNode("span", _hoisted_45, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_46, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_47
                ])
              ], 8, _hoisted_43)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}